export default __webpack_public_path__ + "static/media/JavaScript frameworks (2).ac0bdb40.gif";